import { Component, ElementRef, HostListener, inject } from '@angular/core';

@Component({
  selector: 'app-search-movil',
  templateUrl: './search-movil.html',
  styleUrl: './search-movil.scss',
})
export class SearchMovil {
  private eRef = inject(ElementRef);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (typeof document === 'undefined') return;
    const iconSearch = document.getElementById('openSearch');
    const target = event.target as HTMLElement;
    if (!this.eRef.nativeElement.contains(target) && target !== iconSearch) {
      const box = document.getElementById('searchMovil');
      box!.style.display = 'none';
    }
  }

  closeSearch() {
    const box = document.getElementById('searchMovil');
    box!.style.display = 'none';
  }

  searchIt(event: any) {
    if (event.keyCode == 13 || event.key === 'Enter') {
      const word = event.target.value;
      this.closeSearch();
      if (typeof window !== 'undefined') {
        window.location.href = '/buscador/' + word;
      }
    }
  }
}
